module.exports = __webpack_public_path__ + "static/img/htp_pinzhi.764b0fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/htp_pinzhi.png
// module id = pGsl
// module chunks = 9